import * as React from 'react';

import { Button, Icon } from '@ao-internal/components-react';

import { DrawerHeaderProps } from './types';

export const DrawerHeader = React.forwardRef<
	HTMLButtonElement,
	DrawerHeaderProps
>(({ onClose }, ref) => {
	return (
		<React.Fragment>
			<div className="border-ongreen border-0 border-t-4 border-solid"></div>
			<div
				data-testid="chatbot-drawer-header"
				className="border-gray-40 p-1 bg-white border-0 border-b-2 border-solid"
			>
				<Button
					ref={ref}
					data-testid="chatbot-drawer-header-back-cta"
					data-tag-name="close slideout drawer"
					type="button"
					className="cta cta-tertiary flex items-center justify-between px-4"
					variant="tertiary"
					onClick={onClose}
				>
					<Icon
						icon="chevron-left"
						className="inline-flex mr-2 text-lg leading-none"
					/>
					Back
				</Button>
			</div>
		</React.Fragment>
	);
});

export default DrawerHeader;
